module.exports = __webpack_public_path__ + "media/assets/images/blog/kanbanboard-drag-ticket-2917d771c9729d615caad07771b6ecc9.jpeg";